import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import {
  TextField,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Grid,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import HttpService from "../services/httpService";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(3),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  button: {
    marginTop: theme.spacing(2),
  },
  formRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  formItem: {
    flex: 1,
    marginRight: theme.spacing(2),
  },
  formItemLast: {
    flex: 1,
  },
  table: {
    minWidth: 650,
  },
  tableContainer: {
    marginTop: theme.spacing(3),
  },
  createButton: {
    marginBottom: theme.spacing(2),
    float: "right",
  },
  formField: {
    marginBottom: theme.spacing(2),
    width: "100%",
  },
  tableTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: "bold",
    fontSize: "1.2rem",
    textAlign: "center",
  },
   tableHeader: {
    backgroundColor: '#1C375D',
    "& .MuiTableCell-head": {
      color: "#fff",
      fontWeight: 600,
    },
  },
}));

const CapexProjectCreation = (props) => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [projects, setProjects] = useState([]);
  const [cities, setCities] = useState([]);
  const [experienceCenters, setExperienceCenters] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({
    projectType: "Capex",
    projectName: "",
    // city: { _id: "", name: "" },
    city: "",
    // experienceCenter: { _id: "", name: "" },
    experienceCenter: "",
    area: "",
    startDate: null,
    completionDate: null,
  });

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  
  // const fetchCities = async () => {
  //   try {
  //     props.setLoading(true);
  //     const response = await HttpService.getLocation();
  //     setCities(response.data);
  //   } catch (error) {
  //     props.setSnackInfo(error.message || "Failed to fetch cities", "error");
  //   } finally {
  //     props.setLoading(false);
  //   }
  // };

  const fetchExperienceCenters = async (cityId) => {
    try {
      props.setLoading(true);
      const response = await HttpService.getExperienceCentersByCity(cityId);
      setExperienceCenters(response.data);
    } catch (error) {
      props.setSnackInfo(
        error.message || "Failed to fetch experience centers",
        "error"
      );
    } finally {
      props.setLoading(false);
    }
  };
  
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCreateCapexProject = async () => {
    try {
      props.setLoading(true);
      const response = await HttpService.createCapexProject(formData);
      if (response.status === 200) {
        props.setSnackInfo(response.data, "success");
        setOpenForm(false);
        fetchProjects();
        setFormData({
          projectType: "Capex",
          projectName: "",
          // city: { _id: "", name: "" },
          // experienceCenter: { _id: "", name: "" },
          city: "",         // Changed from object to string
          experienceCenter: "", // Changed from object to string
          area: "",
          startDate: null,
          completionDate: null,
        });
      } else if (response.status === 409) {
        props.setSnackInfo(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error creating project:", error.response.status);
      if (error.response.status === 409) {
        props.setSnackInfo(error.response.data.message, "error");
      } else {
        props.setSnackInfo(
          error.message || "Failed to create project",
          "error"
        );
      }
    } finally {
      props.setLoading(false);
    }
  };

  const handleCancel = () => {
    setOpenForm(false);
    setFormData({
      projectType: "Capex",
      projectName: "",
      // city: { _id: "", name: "" },
      // experienceCenter: { _id: "", name: "" },
      city: "",         // Changed from object to string
      experienceCenter: "", // Changed from object to string
      area: "",
      startDate: null,
      completionDate: null,
    });
  };

  const isFormValid = () => {
    return (
      formData.projectName.trim() !== "" &&
      // formData.city._id !== '' &&
      // formData.experienceCenter._id !== '' &&
      formData.city.trim() !== '' &&
      formData.experienceCenter.trim() !== '' &&
      formData.area.trim() !== "" &&
      formData.startDate !== null &&
      formData.completionDate !== null
    );
  };

  const fetchProjects = async () => {
    try {
      props.setLoading(true);
      const response = await HttpService.getCapexProjects({
        page: page + 1,
        limit: rowsPerPage,
      });
      setProjects(response.data.projectsData);
      setTotalCount(response.data.totalCount);
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
      props.setSnackInfo(error.message || "Failed to fetch projects", "error");
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleMarkCompleteClick = async (projectId) => {
    setSelectedProjectId(projectId);
    setOpenConfirmDialog(true);
  };

  const handleOpenForm = () => {
    setOpenForm(true);
    // fetchCities();
  };

  const handleConfirmComplete = async () => {
    try {
      const response = await HttpService.markProjectComplete(selectedProjectId);
      if (response.status === 200) {
        props.setSnackInfo(
          "Project marked as completed successfully",
          "success"
        );
        fetchProjects();
      } else {
        props.setSnackInfo("Failed to mark project as completed", "error");
      }
    } catch (error) {
      console.error("Error marking project as complete:", error);
      props.setSnackInfo("Failed to mark project as completed", "error");
    } finally {
      setOpenConfirmDialog(false);
      setSelectedProjectId(null);
    }
  };

  const handleCancelComplete = () => {
    setOpenConfirmDialog(false);
    setSelectedProjectId(null);
  };
  
  useEffect(() => {
    fetchProjects();
  }, [page, rowsPerPage]);

  return (
    <div className={classes.root}>
      <Button
        variant="contained"
        color="primary"
        className={classes.createButton}
        onClick={handleOpenForm}
      >
        Create Project
      </Button>
      <Dialog open={openForm} onClose={handleCancel} maxWidth="sm" fullWidth>
        <DialogTitle>Create New Project</DialogTitle>
        <DialogContent>
          <TextField
            className={classes.formField}
            label="Project Type"
            name="projectType"
            value={formData.projectType}
            disabled
            onChange={handleInputChange}
          />
          <TextField
            className={classes.formField}
            label="Name of Project"
            name="projectName"
            value={formData.projectName}
            onChange={handleInputChange}
          />
          {/* <FormControl className={classes.formField}>
            <InputLabel>City Name</InputLabel>
            <Select
              name="city"
              value={formData.city._id}
              onChange={handleInputChange}
            >
              {cities.map((city) => (
                <MenuItem key={city._id} value={city._id}>
                  {city.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl className={classes.formField}>
            <InputLabel>Experience Center Name</InputLabel>
            <Select
              name="experienceCenter"
              value={formData.experienceCenter._id}
              onChange={handleInputChange}
            >
              {experienceCenters.map((center) => (
                <MenuItem key={center._id} value={center._id}>
                  {center.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
          <TextField
            className={classes.formField}
            label="City"
            name="city"
            value={formData.city}
            onChange={handleInputChange}
          />
          <TextField
            className={classes.formField}
            label="Experience Center"
            name="experienceCenter"
            value={formData.experienceCenter}
            onChange={handleInputChange}
          />
          <TextField
            className={classes.formField}
            label="Area"
            name="area"
            value={formData.area}
            onChange={handleInputChange}
          />
          <TextField
            className={classes.formField}
            label="Start Date"
            type="date"
            name="startDate"
            value={formData.startDate || ""}
            onChange={handleInputChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            className={classes.formField}
            label="Completion Date"
            type="date"
            name="completionDate"
            value={formData.completionDate || ""}
            onChange={handleInputChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleCreateCapexProject}
            color="primary"
            variant="contained"
            disabled={!isFormValid()}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <Typography variant="h6" className={classes.tableTitle}>
        Capex Projects
      </Typography>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} aria-label="projects table">
          <TableHead>
            <TableRow className={classes.tableHeader}>
              <TableCell>S.No.</TableCell>
              <TableCell>Project No</TableCell>
              <TableCell>Experience Center</TableCell>
              <TableCell>City</TableCell>
              <TableCell>Area</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell>Project Completion</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {projects.map((project, index) => (
              <TableRow key={project.id}>
                <TableCell component="th">{page * rowsPerPage + index + 1}</TableCell>
                <TableCell component="th">{project.projectNo}</TableCell>
                <TableCell component="th">{project.expCtr}</TableCell>
                <TableCell component="th">{project.city}</TableCell>
                <TableCell component="th">{project.area}</TableCell>
                <TableCell component="th">
                  {project.startDate
                    ? moment(project.startDate).format("DD-MM-YYYY")
                    : "NA"}
                </TableCell>
                <TableCell component="th">
                  {project.projectCompletion
                    ? moment(project.projectCompletion).format("DD-MM-YYYY")
                    : "NA"}
                </TableCell>
                {project.projectCreationStatus !== "Project Under Approval" ? (
                <TableCell component="th">{`${project.projectCreationStatus} - ${project.projectCreationStatusDate ? moment(
                    project.projectCreationStatusDate
                  ).format("DD-MM-YYYY") : "NA"}`}</TableCell>
                  ) : (
                <TableCell>{project.projectCreationStatus}</TableCell>
                )}
                <TableCell component="th">
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    disabled={project.projectCreationStatus !== "Approved"}
                    onClick={() => handleMarkCompleteClick(project.id)}
                  >
                    Mark as Completed
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 50, 100]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
      <Dialog
        open={openConfirmDialog}
        onClose={handleCancelComplete}
        aria-labelledby="confirm-dialog-title"
      >
        <DialogTitle id="confirm-dialog-title">Confirm Action</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to mark this project as completed?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelComplete} color="primary">
            No
          </Button>
          <Button
            onClick={handleConfirmComplete}
            color="primary"
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default connect(null, { setLoading, setSnackInfo })(
  CapexProjectCreation
);